export const MEMBER_DATABASE = 'member_database';

export function isMemberDatabasePublicUrl(url: string): boolean {
  if (!url) {
    return false;
  }
  const segments = url.split('?')[0].split('/').filter(Boolean);
  return segments.includes(MEMBER_DATABASE);
}
